import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GetOtpResponse } from '../../interfaces/get-otp.interface';
import { Global } from '../global';

@Injectable({
  providedIn: 'root'
})
export class GetOtpService {

  private API_URL: string;

  constructor(private httpClient: HttpClient) {
    this.API_URL = Global.url+'/cx/getcode'
  }

  getOtp(token: string, request: any): Observable<GetOtpResponse> {
    return this.httpClient.post<GetOtpResponse>(this.API_URL, request , {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'        
      }
    });
  }
}
